import {PollyVoice} from './polly-voice';

export interface TtsApplicationDefaultsJSON {
  tts_application_id: number;
  tts_application_name: string;
  tts_application_display_label: string;
  tts_polly_output_format: string;
  tts_polly_sample_rate: number;
  tts_polly_text_type: string;
  tts_output_type: string;
  s3_path: string;
  audio_conversion_command: string;
  audio_conversion_args: string;
  audio_conversion_input: string;
  audio_conversion_output: string;
  tts_default_voice_id: number;
  tts_polly_voice_id: string;
  tts_polly_locale: string;
  xcore_locale: string;
}

export class TtsApplication {
  constructor(
    public id: number,
    public name: string,
    public displayLabel: string,
    public outputype: string,
    public s3Path: string,
    public audioCommand: string,
    public audioArgs: string,
    public audioInput: string,
    public audioOutput: string,
    public pollyOutputFormat: string,
    public pollySampleRate: number,
    public pollyTextType: string) {
  }

}

export class TtsDefaultVoice {
  public voice: PollyVoice;

  constructor(
    public id: number,
    public xcoreLocale: string,
    public pollyLocale: string,
    public pollyVoiceId: string
  ) {
  }
}

export class TtsApplicationDefaults {
  constructor(public app: TtsApplication, public defVoice: TtsDefaultVoice) {
  }


  static parse(json: TtsApplicationDefaultsJSON): TtsApplicationDefaults {
    const app = new TtsApplication(
      json.tts_application_id,
      json.tts_application_name,
      json.tts_application_display_label,
      json.tts_output_type,
      json.s3_path,
      json.audio_conversion_command,
      json.audio_conversion_args,
      json.audio_conversion_input,
      json.audio_conversion_output,
      json.tts_polly_output_format,
      json.tts_polly_sample_rate,
      json.tts_polly_text_type
    );
    const dv = new TtsDefaultVoice(
      json.tts_default_voice_id,
      json.xcore_locale,
      json.tts_polly_locale,
      json.tts_polly_voice_id
    );
    return new TtsApplicationDefaults(app, dv);
  }
}
